import { use$ } from '@legendapp/state/react';
import { ActionIcon, Flex, Group } from '@mantine/core';
import { MinusIcon, PlusIcon } from '@phosphor-icons/react';
import { manualBetState$ } from '../../../state';
import { freeBetState$ } from '../../../state/free-bet.state';
import { ManualBetCashoutButton } from './ManualBetCashoutButton';
import { ManualBetPickRandomBrickButton } from './ManualBetPickRandomBrickButton';
import { MobileManualBetStartButton } from './MobileManualBetStartButton';

export const ManualBetMobileActions = () => {
  const isBetting = use$(manualBetState$.isBetting);
  const isFreeBetting = use$(freeBetState$.isActive);

  return (
    <Group
      bg="dark.7"
      bottom={0}
      data-test-id="manual-bet-actions-mobile"
      h={isBetting ? 140 : 80}
      hiddenFrom="lg"
      left={0}
      p={16}
      pos="fixed"
      right={0}
      style={{
        zIndex: 20,
        borderTop: '2px solid var(--mantine-color-dark-5)',
      }}
    >
      {isBetting ? (
        <Flex direction="column-reverse" gap="md" w="100%">
          <ManualBetPickRandomBrickButton data-test-id="mobile-manual-bet-pick-random-brick-button" />

          <ManualBetCashoutButton data-test-id="mobile-manual-bet-cashout-button" />
        </Flex>
      ) : (
        <Group justify="space-between" w="100%" wrap="nowrap">
          <ActionIcon
            bg="dark.4"
            data-test-id="mobile-manual-bet-decrement-bet-amount-button"
            disabled={isFreeBetting}
            onClick={manualBetState$.decrementBetAmount}
          >
            <MinusIcon />
          </ActionIcon>
          <MobileManualBetStartButton />
          <ActionIcon
            bg="dark.4"
            data-test-id="mobile-manual-bet-increment-bet-amount-button"
            disabled={isFreeBetting}
            onClick={manualBetState$.incrementBetAmount}
          >
            <PlusIcon />
          </ActionIcon>
        </Group>
      )}
    </Group>
  );
};
